var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c("template", { slot: "header" }, [_vm._v("代码高亮组件")]),
      _c(
        "el-card",
        { staticClass: "d2-mb", attrs: { shadow: "never" } },
        [
          _c("p", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v("javascript")
          ]),
          _c("d2-highlight", { attrs: { code: _vm.codeJavascript } })
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "d2-mb", attrs: { shadow: "never" } },
        [
          _c("p", { attrs: { slot: "title" }, slot: "title" }, [_vm._v("css")]),
          _c("d2-highlight", { attrs: { code: _vm.codeCSS } })
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "d2-mb", attrs: { shadow: "never" } },
        [
          _c("p", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v("scss")
          ]),
          _c("d2-highlight", { attrs: { code: _vm.codeSCSS } })
        ],
        1
      ),
      _c(
        "el-card",
        { attrs: { shadow: "never" } },
        [
          _c("p", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v("html")
          ]),
          _c("d2-highlight", { attrs: { code: _vm.codeHTML } })
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }